import {graphql} from 'react-relay';
import {omit} from 'lodash';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateCollaboratorSeatRestrictionMutation($input: UpdateCompanyInput!) {
		updateCompany(input: $input) {
			company {
				id
				restrictCollaboratorSeatPermissions
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function getOptimisticResponse(input) {
	return {
		updateCompany: {
			company: {
				id: input.id,
				restrictCollaboratorSeatPermissions: input.restrictCollaboratorSeatPermissions,
			},
		},
	};
}

function commit(environment, input, onSuccess, onError, uploadables) {
	tracking.trackEvent('Company Updated', {_Changed: ['restrictCollaboratorSeatPermissions']});

	// ID is needed for the optimistic response, but must not be sent as a variable
	const variablesNoID = omit({...input}, ['id']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...variablesNoID}},
		uploadables,
		configs: getConfigs(),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
